import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, WithTooltip } from '../Elements';
import { CustomIcon } from '@p81-common/ui';
import { links } from 'data/constants';

import classes from './IconWithTooltip.module.scss';

const IconWithTooltip = ({
  text,
  icon,
  iconFromMNX,
  color,
  size = '16px',
  className,

  ...other
}) => {
  return (
    <WithTooltip text={text} {...other}>
      <div className={cn(classes.wrap, className)}>
        {iconFromMNX ? (
          <CustomIcon
            src={`${links.imagesBaseUrl}/${icon}`}
            className={classes.salesforce}
            color={color}
          />
        ) : (
          <Icon icon={icon} color={color} size={size} />
        )}
      </div>
    </WithTooltip>
  );
};

IconWithTooltip.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  iconFromMNX: PropTypes.bool
};

export default IconWithTooltip;
